function isMedSeekApp() {
  if (window.ISMEDSEEKAPP) return true
  const host = window.location.hostname
  console.log('host', host)
  return host === 'localhost' || host === '127.0.0.1'
}

function getToken() {
  return localStorage.getItem('medseekAuth') || (window.head && window.head.auth)
}

function getApiUrl(path) {
  return `${String(Global_apiserver).replace(/\/$/, '')}/medseekcn/doctorTool/${path.replace(/^\//, '')}`
}

function getErrorMessage(response) {
  return response && response.data && (response.data.message || response.data.msg)
}

async function request(vm, method, path, data) {
  const token = getToken()
  if (!token) return null

  const config = {
    method,
    url: getApiUrl(path),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  if (method === 'get') {
    config.params = data
  } else {
    config.data = data
  }

  const response = await vm.$axios(config)
  if (!response.data || String(response.data.code) !== '0') {
    const error = new Error(getErrorMessage(response) || '操作失败，请重试')
    error.response = response
    throw error
  }
  return response.data.data
}

export function medSeekToolRequest(vm, method, path, data) {
  return request(vm, method, path, data)
}

export function recordMedSeekTool(vm, tool) {
  return request(vm, 'post', '/frequent', tool)
}

export function getMedSeekFavoriteStatus(vm, toolType, toolId) {
  return request(vm, 'get', 'favorite/status', { toolType, toolId })
}

export function getMedSeekFrequentList(vm, pageNum, size) {
  return request(vm, 'get', 'frequent/list', { pageNum, size })
}

export function getMedSeekFavoriteList(vm, pageNum, size) {
  return request(vm, 'get', 'favorite/list', { pageNum, size })
}

export function setMedSeekFavorite(vm, tool, favorite) {
  return request(vm, 'post', 'favorite', {
    ...tool,
    favorite: favorite ? 1 : 0,
  })
}

export { isMedSeekApp }
